import React, { FC, PropsWithChildren, ReactNode } from "react";

import { Paper, Stack, Typography } from "@mui/material";

type PPLBlockProps = PropsWithChildren<{
  title: string;
  actions?: ReactNode;
  depth?: number;
}>;
const PPLBlock: FC<PPLBlockProps> = ({ title, actions, depth, children }) => {
  return (
    <Paper elevation={depth === 1 ? 5 : 1} sx={{ p: 1 }}>
      <Stack gap={1}>
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant={depth === 1 ? "h6" : "h5"}>{title}</Typography>
          {actions}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};
export default PPLBlock;
